import {sortByKey} from 'presentation/utils';
import {makePostProvidersDentalGuide} from 'main/factories/usecases/private/guide-flow/remote-dental-guide/post-providers-factory';
import {PostProvidersDentalGuideParams} from 'domain/usecases/private/guide-flow/dental-guide/post-providers';

async function getOdontoProviders(params: PostProvidersDentalGuideParams) {
	const response = await makePostProvidersDentalGuide().post(params);

	if (!response.prestadores || response.prestadores.length === 0) {
		return [];
	}

	const sortedProvidersByFantasyName = sortByKey(response.prestadores, 'nomeFantasia');

	return sortedProvidersByFantasyName;
}

export {getOdontoProviders};
